import React, { FunctionComponent } from 'react';
import { formatInTimeZone } from 'date-fns-tz';

type Props = {
  fieldValue: string[];
  record?: Record<string, any>;
  source: Array<number | string>;
  options?: Record<string, unknown>;
};

const formatDate = (date?: Date | string, dateFormat = 'yyyy-MM-DD'): string =>
  date
    ? formatInTimeZone(new Date(date), 'America/Chicago', dateFormat)
    : 'Ongoing';

const DATE_FORMAT = 'MMM do yyyy p';

export const renderActiveDates = (
  startDate: Date | string,
  endDate?: Date | string,
): JSX.Element => (
  <>
    <span style={{ width: '6.6rem' }}>
      {formatDate(startDate, DATE_FORMAT)}
    </span>
    <span> - </span>
    <span style={{ width: '6.6rem' }}>
      {formatDate(endDate, DATE_FORMAT)} &nbsp;
    </span>
  </>
);

const ActiveSegmentDates: FunctionComponent<Props> = ({ record }) => {
  return record ? (
    renderActiveDates(record['startDate'], record['endDate'])
  ) : (
    <span>N/A</span>
  );
};

export default ActiveSegmentDates;
